<template>
  <div id="AddMemberDataContainer" class="vs-con-loading__container">

    <div class="vx-row">
      <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
        <div class="mb-3">
          <vs-input :label="$t('member_name')" v-model="memberFormData.name" class="w-full"/>
          <validation-error :model-error="memberFormErrors.name"></validation-error>
        </div>
      </div>
      <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
        <div class="mb-3">
          <vs-input :label="$t('caller_company_name')" v-model="memberFormData.company_name" class="w-full"/>
          <validation-error :model-error="memberFormErrors.company_name"></validation-error>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
        <div class="mb-3">
          <vs-input :label="$t('mobile')" v-model="memberFormData.mobile" class="w-full"/>
          <validation-error :model-error="memberFormErrors.mobile"></validation-error>
        </div>
      </div>
      <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
        <div class="mb-3">
          <vs-input :label="$t('landline')" v-model="memberFormData.landline" class="w-full"/>
          <validation-error :model-error="memberFormErrors.landline"></validation-error>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
        <div class="mb-3">
          <vs-input type="number" :label="$t('age')" v-model="memberFormData.age" class="w-full"/>
          <validation-error :model-error="memberFormErrors.age"></validation-error>
        </div>
      </div>
      <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
        <div class="mb-3">
          <label class="vs-input--label" v-text="$t('member_groups')"></label>
<!--          <v-select :options="clientGroupOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="memberFormData.member_group" class="mb-3" />-->
          <select v-model="memberFormData.member_group" class="vs-inputx vs-input--input normal mb-3">
            <option value="">{{ $t('please_select') }}</option>
            <option v-for="(option, key) in clientGroupOptions" :key="'member_group_' + key" :value="option.value">{{ option.label }}</option>
          </select>
          <validation-error :model-error="memberFormErrors.member_group"></validation-error>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
        <div class="mb-3">
          <label class="vs-input--label" v-text="$t('membership_level')"></label>
<!--          <v-select :options="clientLevelOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="memberFormData.member_client_level" class="mb-3" />-->
          <select v-model="memberFormData.member_client_level" class="vs-inputx vs-input--input normal mb-3">
            <option value="">{{ $t('please_select') }}</option>
            <option v-for="(option, key) in clientLevelOptions" :key="'member_client_level_' + key" :value="option.value">{{ option.label }}</option>
          </select>
          <validation-error :model-error="memberFormErrors.member_client_level"></validation-error>
        </div>
      </div>
      <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
        <div class="mb-3">
          <vs-input :label="$t('address')" v-model="memberFormData.address" class="w-full"/>
          <validation-error :model-error="memberFormErrors.address"></validation-error>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mb-3">
          <vs-input :label="$t('email')" type="email" v-model="memberFormData.emails" class="w-full"/>
          <validation-error :model-error="memberFormErrors.emails"></validation-error>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-1/2 sm:w-1/2 w-full" v-for="(customField, key) in customFields" v-bind:key="key" v-if="customFields.length > 0">
        <div class="mb-3" >
          <label class="vs-input--label" v-text="customField.name"></label>
          <input type="text" class="vs-inputx vs-input--input normal w-full member_custom_field" :id="customField.custom_field_type_id">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { EventBus } from '@/../eventbus'
import Member from '@/models/Member'

export default {
  name: 'SharedAddMember',
  data () {
    return {
      memberFormData: {},
      memberFormErrors: {}
    }
  },
  props: {
    clientGroupOptions: {
      required: true,
      type: [Object, Array]
    },
    clientLevelOptions: {
      required: true,
      type: [Object, Array]
    },
    customFields: {
      required: true,
      type: [Object, Array]
    }
  },
  computed: {

  },
  mounted () {
    this.initAddMemberFormData()
    EventBus.$on('initAddMemberFormData', this.initAddMemberFormData)
    EventBus.$on('storeMember', this.storeMember)
  },
  methods: {
    async storeMember () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addMemberButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)
          const memberFormData = this.memberFormData

          const dataMemberCustomFields = []

          const memberCustomFields = Object.values(this.customFields)

          for (const i in memberCustomFields) {

            const memberCustomFieldId = `member_custom_field_${memberCustomFields[i].id}`
            const memberCustomField = document.getElementById(memberCustomFieldId)
            const memberCustomFieldValue = memberCustomField.value

            const data = `${memberCustomFieldId}:${memberCustomFieldValue}`
            dataMemberCustomFields.push(data)
          }

          memberFormData.custom_fields = dataMemberCustomFields

          await Member.save(memberFormData)

          this.$store.dispatch('setIsFormInProgress', false)
          this.initAddMemberFormData()
          this.$emit('storeMemberSuccess')
        }

      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.$store.dispatch('setIsFormInProgress', false)
        this.memberFormErrors = errors.validationErrors
      }
      this.$vs.loading.close('#addMemberButton > .con-vs-loading')
    },
    initAddMemberFormData () {
      this.memberFormData = {
        name: '',
        company_name: '',
        emails: '',
        age: '',
        address: '',
        member_group: '',
        member_client_level: '',
        is_active: '',
        id: '',
        landline: '',
        mobile: ''
      }
      this.memberFormErrors = {}

      const memberCustomFields = Object.values(this.customFields)
      for (const i in memberCustomFields) {
        const customFieldId = `member_custom_field_${  memberCustomFields[i].id}`
        document.getElementById(customFieldId).value = ''
      }
    }
  }
}
</script>

<style lang="scss">
  #addMemberButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
